/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentTaken/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import Button from 'DesignSystem/Button/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentTaken({
  children,
  viewPath = "/App/Form/Data/ProvideData/AppointmentSlot/Notifications/AppointmentTaken",
  marginTop = 0,
  onClick
  
}) {
  return (<React.Fragment
>
<div
  data-testid="AppointmentTaken.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="AppointmentTaken.Text"
  data-view-path={viewPath}
 style={{'--mt-1-1qa9Rt': typeof marginTop === 'number' ? `${marginTop}px` : marginTop}}
 className={`views-text ${styles.Text}`}
>
Someone already booked your date and time
</span>
<Button
  viewPath={`${viewPath}/Button`}
 onClick={onClick}
 text="Select new date"
 alignSelf="center"
/>
</div>
{children}
</React.Fragment>)
}